import {GetObligationPdf} from 'domain/usecases';
import {RemoteGetObligationPdf} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {MyPaymentsFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetObligationPdf = (): GetObligationPdf =>
	new RemoteGetObligationPdf(
		makeBFFApiUrl(MyPaymentsFlowEndPoints.paymentsPdf),
		makeAuthorizeHttpClientDecorator(),
	);
